import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5),
    position: 'relative',

    color: theme.palette.text.secondary,
    maxWidth: 440,
  },

  guide: {
    alignItems: 'flex-start',
    paddingLeft: theme.spacing(8),

    '& br': {
      display: 'none',
    },

    '& li': {
      maxWidth: 360,
    },
  },
}));
